import { render, staticRenderFns } from "./recruitlogin.vue?vue&type=template&id=32e567d5&scoped=true"
import script from "./recruitlogin.vue?vue&type=script&lang=js"
export * from "./recruitlogin.vue?vue&type=script&lang=js"
import style0 from "./recruitlogin.vue?vue&type=style&index=0&id=32e567d5&prod&lang=css"
import style1 from "./recruitlogin.vue?vue&type=style&index=1&id=32e567d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e567d5",
  null
  
)

export default component.exports